function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import { TableFooter, TablePagination, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TablePaginationActionsWrapped from './TablePaginationActions';

var Pagination = function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Pagination.prototype.labelDisplayedRows = function labelDisplayedRows(data) {
    var from = data.from,
        to = data.to,
        count = data.count;
    return from + ' - ' + to + ' sur ' + count;
  };

  Pagination.prototype.render = function render() {
    if (!this.props.showPagination) return null;
    var _props = this.props,
        nbDatas = _props.nbDatas,
        rowsPerPage = _props.rowsPerPage,
        page = _props.page,
        handleChangePage = _props.handleChangePage,
        handleChangeRowsPerPage = _props.handleChangeRowsPerPage,
        labelRowsPerPage = _props.labelRowsPerPage,
        labelDisplayedRows = _props.labelDisplayedRows,
        rowsPerPageOptions = _props.rowsPerPageOptions;
    return React.createElement(TableFooter, null, React.createElement(TableRow, null, React.createElement(TablePagination, {
      count: nbDatas,
      rowsPerPage: rowsPerPage,
      page: page,
      onChangePage: handleChangePage,
      onChangeRowsPerPage: handleChangeRowsPerPage,
      ActionsComponent: TablePaginationActionsWrapped,
      labelRowsPerPage: !!labelRowsPerPage ? labelRowsPerPage : 'Lignes par page',
      labelDisplayedRows: !!labelDisplayedRows ? labelDisplayedRows : this.labelDisplayedRows,
      rowsPerPageOptions: !!rowsPerPageOptions ? rowsPerPageOptions : [5, 10, 25]
    })));
  };

  return Pagination;
}(Component);

Pagination.propTypes = process.env.NODE_ENV !== "production" ? {
  showPagination: PropTypes.bool.isRequired,
  nbDatas: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired,
  labelRowsPerPage: PropTypes.string,
  labelDisplayedRows: PropTypes.func,
  rowsPerPageOptions: PropTypes.array
} : {};
export default Pagination;